import { useCallback, useMemo, useState } from 'react';
import { noop } from 'lodash';
import type { WorkspaceNotificationsWarningModalProps } from '../components';
import { WorkspaceNotificationsWarningModal } from '../components';

export type UseWorkspaceNotificationsWarningModalReturn = {
  workspaceNotificationsWarningModal: React.ReactNode;
  showWorkspaceNotificationsWarningModal: (
    workspaceId: string,
    onRequestClose?: () => void
  ) => void;
  hideWorkspaceNotificationsWarningModal: () => void;
};

export const useWorkspaceNotificationsWarningModal =
  (): UseWorkspaceNotificationsWarningModalReturn => {
    const [props, setProps] = useState<WorkspaceNotificationsWarningModalProps>(
      {
        workspaceId: '',
        isShowing: false,
        onRequestClose: noop,
      }
    );

    const hideWorkspaceNotificationsWarningModal = useCallback(() => {
      setProps((prev) => ({
        ...prev,
        workspaceId: '',
        isShowing: false,
        onRequestClose: noop,
      }));
    }, []);

    const showWorkspaceNotificationsWarningModal = useCallback(
      (
        workspaceId: string,
        onRequestClose = hideWorkspaceNotificationsWarningModal
      ) => {
        setProps((prev) => ({
          ...prev,
          onRequestClose,
          workspaceId,
          isShowing: true,
        }));
      },
      [hideWorkspaceNotificationsWarningModal]
    );

    const workspaceNotificationsWarningModal = useMemo(() => {
      return <WorkspaceNotificationsWarningModal {...props} />;
    }, [props]);

    return {
      workspaceNotificationsWarningModal,
      showWorkspaceNotificationsWarningModal,
      hideWorkspaceNotificationsWarningModal,
    };
  };
